import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import DownIcon from "@mui/icons-material/KeyboardArrowDown";
import styledComponent from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import CardLoadingSvg from "../../../../Images/cardLoading.svg";
import { addProjeto } from "../../../../Services/cardService";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  gap: "0.25rem",
  padding: "0.25rem 0.5rem",
  color: "black",
  backgroundColor: "rgba(0, 0, 0, 0.03)",
  border: "none",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-around",

  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  "&:active": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
});

const LoadingBox = styledComponent.div`
	height: 3rem;
	width: 8rem;
	padding: 0.5rem 3rem;
	background-image: url(${(props) => props.image});
	background-position: center;
	background-repeat: no-repeat;
`;

const Span = styledComponent.span`
font-size: 0.85rem;
display:block;
`;

const StyledIcon = styled(DownIcon)({
  display: "block",
  fontSize: "1.3rem",
});

export default function DropdownProjetos() {
  const thisCard = useSelector((state) => state.card);

  const dispatch = useDispatch();

  const fictitiousProjetos = [
    {
      _id: "8aa22b6d0fb648d2b4ab1d72",
      description: "EF-151 - Ferrovia Norte-Sul",
    },
    { _id: "d19976df3e564ec58ef6f915", description: "EF-170 - Ferrogrão" },
    {
      _id: "682623619101b80642c7265c",
      description: "EF-232 - Ferrovia Transnordestina",
    },
    {
      _id: "a6fab99e0217497eb1009cb6",
      description: "EF-232 - Ligação da FNS com a Transnortdestina",
    },
    {
      _id: "b248c0d2d9ba462aba1da733",
      description: "EF-267 - Ferrovia do Pantanal",
    },
    { _id: "01fb307e974a46d3af3fabfa", description: "EF-277 - Ferroeste" },
    {
      _id: "dbe6aeb03eb34ef7a8f236db",
      description: "EF-280 - Corretor Ferroviário de Santa Catarina",
    },
    {
      _id: "d1ce54c9321b4ca98461749f",
      description: "EF-334 - FIOL - Ferrovia de Integração Oeste-Leste",
    },
    {
      _id: "c3ce1d07e941418da7ab52ad",
      description: "EF-354 - FICO - Ferrovia de Integração Centro Oeste",
    },
    {
      _id: "9368ce71b161495fa3407ae3",
      description:
        "EF-354 - Ferrovia Transconstinental/Ferrovia de integração Centro Oeste",
    },
    {
      _id: "00f9c0004f654980afabb11a",
      description: "EF-354 - Ferrovia Transcontinental",
    },
    { _id: "fcca502cd4a7492d87666079", description: "Estudos e Projetos" },
    { _id: "8d7b89f12c844c51979b9a5a", description: "Geral" },
    { _id: "ae4e4218a81b45e581425c3d", description: "Não se aplica" },
  ];

  const [projetoData, setProjetoData] = useState(fictitiousProjetos);
  const [projeto, setProjeto] = useState(thisCard.projetos);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProjeto, setSelectedProjeto] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);
    setLoading(true);
    try {
      //      await getListProduto(true);
    } catch (error) {
      console.error("Falha ao buscar quadros:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projeto) {
      const selected = projetoData.find((p) => p._id === projeto);
      if (selected) {
        setSelectedProjeto(selected);
      }
    }
  }, [projeto, projetoData]);

  const handleSelect = async (item) => {
    setSelectedProjeto(item);
    setAnchorEl(null);
    await addProjeto(
      thisCard.cardId,
      thisCard.listId,
      thisCard.boardId,
      item._id,
      dispatch
    );
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <BootstrapButton
        id="demo-positioned-button"
        aria-controls="demo-positioned-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        type="button"
      >
        <Span>{selectedProjeto?.description ?? "Selecione"}</Span>
        <Span>
          <StyledIcon />
        </Span>
      </BootstrapButton>
      {Object.keys(projetoData).length > 0 && (
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {!loading ? (
            projetoData.map((item) => {
              return (
                <MenuItem key={item._id} onClick={() => handleSelect(item)}>
                  <Span>{item.description}</Span>
                </MenuItem>
              );
            })
          ) : (
            <LoadingBox image={CardLoadingSvg} />
          )}
        </Menu>
      )}
    </div>
  );
}
